import { FLOW_STEP_DATE, FLOW_STEP_PRODUCT, FLOW_STEP_REVIEW, FLOW_STEP_VEHICLE } from 'subscription-flow/constants'

import DateSelection from './flow-steps/DateSelection'
import VehicleSelection from './flow-steps/VehicleSelection'
import ProductSelection from 'booking/components/flow-steps/ProductSelection'
import ReviewPay from './flow-steps/ReviewPay'
import GuestCheckoutVehicleSelection from 'booking/components/GuestCheckoutComponents/GuestCheckoutVehicleSelection'

import styles from './flow-steps/styles.module.scss'

const HourlyFlow = ({
    activeStep,
    grsId,
    onNext,
    setStartDate,
    setProduct,
    bookingData,
    setVehicle,
    rate,
    currentItemIndex,
    rateVehicle,
    errorMessage,
    waitingListKey,
    setOutboundNumber,
    setInboundNumber,
    setAdditionalServices,
    showPixPaymentMethod,
    isParkNowFlow,
    nonBookable,
    guestCheckoutEnabled,
    analyticsFlowType,
}) => (
    <div className={guestCheckoutEnabled && styles.hourlyFlow}>
        {activeStep === FLOW_STEP_DATE && (
            <DateSelection
                grsId={grsId}
                onNext={onNext}
                setStartDate={setStartDate}
                isParkNowFlow={isParkNowFlow}
                nonBookable={nonBookable}
            />
        )}
        {activeStep === FLOW_STEP_PRODUCT && (
            <ProductSelection
                grsId={grsId}
                onNext={onNext}
                setProduct={setProduct}
                bookingData={bookingData}
                setAdditionalServices={setAdditionalServices}
                nonBookable={nonBookable}
                analyticsFlowType={analyticsFlowType}
            />
        )}
        {activeStep === FLOW_STEP_VEHICLE &&
            (guestCheckoutEnabled ? (
                <GuestCheckoutVehicleSelection
                    onNext={onNext}
                    setVehicle={setVehicle}
                    analyticsFlowType={analyticsFlowType}
                />
            ) : (
                <VehicleSelection
                    onNext={onNext}
                    setProduct={setProduct}
                    setVehicle={setVehicle}
                    rate={rateVehicle}
                    currentItemIndex={currentItemIndex}
                    analyticsFlowType={analyticsFlowType}
                />
            ))}
        {activeStep === FLOW_STEP_REVIEW && !errorMessage && (
            <ReviewPay
                grsId={grsId}
                bookingData={bookingData}
                currentItemIndex={currentItemIndex}
                waitingListKey={waitingListKey}
                rate={rate}
                setOutboundNumber={setOutboundNumber}
                setInboundNumber={setInboundNumber}
                showPixPaymentMethod={showPixPaymentMethod}
                analyticsFlowType={analyticsFlowType}
            />
        )}
    </div>
)
export { HourlyFlow }
